/* ==========================================================================
   Deco Deco theme — assets/product.js
   Product page: variant selection, gallery + lightbox, bundle options
   (replacement for Infinite Options), ajax add-to-cart, sticky cart bar,
   related products. Depends on assets/theme.js (window.theme).
   ========================================================================== */
(() => {
  'use strict';

  const T = window.theme || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const root = $('[data-product]');
  const jsonEl = $('[data-product-json]');
  if (!root || !jsonEl) return;

  const data = JSON.parse(jsonEl.textContent);
  const form = $('[data-product-form]', root);
  const idInput = form ? $('[data-variant-id]', form) : null;
  const addBtn = form ? $('[data-add-to-cart]', form) : null;
  const addText = form ? $('[data-add-to-cart-text]', form) : null;
  const errors = form ? $('[data-form-errors]', form) : null;
  const priceWrap = $('[data-product-price-wrapper]', root);
  const notify = $('[data-notify]', root);
  const notifyProduct = $('[data-notify-product]');
  const cartBar = $('[data-cart-bar]');
  const cartBarPrice = $('[data-cart-bar-price]');

  const showError = (message) => { if (!errors) return T.toast(message); errors.textContent = message; errors.hidden = false; };
  const hideError = () => { if (errors) errors.hidden = true; };

  /* --------------------------------------------------------------- gallery */
  const gallery = (() => {
    const stage = $('[data-gallery-track]', root);
    const slides = $$('[data-gallery-slide]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    let index = 0;

    const keepThumbVisible = (thumb) => {
      const container = thumb.parentElement;
      if (!container) return;
      const r = thumb.getBoundingClientRect();
      const c = container.getBoundingClientRect();
      if (r.top < c.top || r.bottom > c.bottom) container.scrollTop += r.top - c.top - 8;
      if (r.left < c.left || r.right > c.right) container.scrollLeft += r.left - c.left - 8;
    };
    const setActive = (i) => {
      index = i;
      thumbs.forEach((t, j) => {
        t.classList.toggle('is-active', j === i);
        t.setAttribute('aria-selected', String(j === i));
      });
      if (thumbs[i]) keepThumbVisible(thumbs[i]);
    };
    const goTo = (i, smooth = true) => {
      if (!stage || !slides.length) return;
      const target = (i + slides.length) % slides.length;
      stage.scrollTo({ left: slides[target].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(target);
    };
    const goToMedia = (mediaId) => {
      const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (i >= 0 && i !== index) goTo(i);
    };

    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));

    let scrollTimer;
    if (stage) stage.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const i = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
        if (i !== index && slides[i]) setActive(i);
      }, 80);
    }, { passive: true });

    /* Lightbox */
    const lightbox = $('[data-lightbox]');
    const lightboxImg = lightbox ? $('[data-lightbox-img]', lightbox) : null;
    let lbIndex = 0;
    const showLightbox = (i) => {
      if (!lightbox || !data.media.length) return;
      lbIndex = (i + data.media.length) % data.media.length;
      lightboxImg.src = data.media[lbIndex].src;
      lightboxImg.alt = data.media[lbIndex].alt || '';
      if (!lightbox.open) lightbox.showModal();
    };
    const zoom = $('[data-gallery-zoom]', root);
    if (zoom) zoom.addEventListener('click', () => showLightbox(index));
    slides.forEach((s, i) => s.addEventListener('click', (e) => { if (e.target.closest('img')) showLightbox(i); }));
    if (lightbox) {
      const lbPrev = $('[data-lightbox-prev]', lightbox);
      const lbNext = $('[data-lightbox-next]', lightbox);
      if (lbPrev) lbPrev.addEventListener('click', () => showLightbox(lbIndex - 1));
      if (lbNext) lbNext.addEventListener('click', () => showLightbox(lbIndex + 1));
      lightbox.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') showLightbox(lbIndex - 1);
        if (e.key === 'ArrowRight') showLightbox(lbIndex + 1);
      });
      lightbox.addEventListener('close', () => goTo(lbIndex, false));
    }

    return { goTo, goToMedia };
  })();

  /* -------------------------------------------------------------- variants */
  const optionInputs = () => $$('[data-option-input]', root);
  const selectedOptions = () => {
    const opts = [];
    optionInputs().forEach((input) => {
      const pos = Number(input.dataset.optionPosition) - 1;
      if (input.type === 'radio') { if (input.checked) opts[pos] = input.value; }
      else opts[pos] = input.value;
    });
    return opts;
  };
  const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
  let currentVariant = data.variants.find((v) => idInput && String(v.id) === idInput.value) || data.variants[0];

  const renderPrice = (v) => {
    if (!priceWrap) return;
    const box = $('.price', priceWrap);
    const price = $('[data-price]', priceWrap);
    if (price) price.textContent = T.formatMoney(v.price);
    let compare = $('[data-compare-price]', priceWrap);
    if (v.compareAtPrice > v.price) {
      if (!compare && box) {
        compare = document.createElement('s');
        compare.className = 'price__compare';
        compare.setAttribute('data-compare-price', '');
        box.appendChild(compare);
      }
      if (compare) compare.textContent = T.formatMoney(v.compareAtPrice);
      if (box) box.classList.add('price--sale');
    } else {
      if (compare) compare.remove();
      if (box) box.classList.remove('price--sale');
    }
    if (cartBarPrice) cartBarPrice.textContent = T.formatMoney(v.price);
  };

  /* Bundle picks are counted lists (one entry per unit; the same swatch may appear more than once). */
  const selectionOrder = new Map();
  const picksOf = (group) => selectionOrder.get(group) || [];

  /* Paid extras: sum of every picked unit in groups with data-role="extra". */
  const extrasTotal = () => $$('[data-bundle-group][data-role="extra"]', root)
    .reduce((sum, group) => sum + picksOf(group).reduce((s, input) => s + (Number(input.dataset.price) || 0), 0), 0);

  const renderButtonLabel = (v) => {
    if (!addText) return;
    if (!v) { addText.textContent = T.strings.unavailable; return; }
    if (!v.available) { addText.textContent = T.strings.soldOut; return; }
    const extras = extrasTotal();
    addText.textContent = extras > 0 ? `${T.strings.addToCart} · ${T.formatMoney(v.price + extras)}` : T.strings.addToCart;
  };

  const renderExtrasTotal = () => {
    const box = $('[data-bundle-extras-total]', root);
    if (!box) return;
    const extras = extrasTotal();
    box.hidden = extras === 0;
    const amount = $('[data-bundle-extras-amount]', box);
    if (amount) amount.textContent = `+${T.formatMoney(extras)}`;
  };

  /* All required groups (data-role="included") must have exactly their max picks. */
  const bundleComplete = () => $$('[data-bundle-group][data-role="included"]', root)
    .every((group) => picksOf(group).length >= (Number(group.dataset.max) || 0));

  const bundleHint = $('[data-bundle-hint]', root);
  const renderButtonState = (v) => {
    if (!addBtn) return;
    const complete = bundleComplete();
    addBtn.disabled = !v || !v.available || !complete;
    if (bundleHint) bundleHint.hidden = complete || !v || !v.available;
  };

  const renderAvailability = (v) => {
    if (!addBtn || !addText) return;
    if (!v) {
      renderButtonState(null);
      renderButtonLabel(null);
      if (notify) notify.hidden = true;
      return;
    }
    renderButtonState(v);
    renderButtonLabel(v);
    if (notify) notify.hidden = v.available;
    if (notifyProduct) notifyProduct.value = `${data.title} – ${v.title}`;
  };

  /* A pick chip: swatch color / thumbnail dot + name, optionally with a remove button (index into the
     group's picks list). Used by the bundle strips and by the First / Second Color legends. */
  const chipFor = (input, removeIndex) => {
    const swatch = input.closest('.swatch');
    const source = swatch ? $('.swatch__chip', swatch) : null;
    const chip = document.createElement('span');
    chip.className = removeIndex == null ? 'pick-chip pick-chip--static' : 'pick-chip';
    if (swatch && swatch.dataset.swatch) chip.dataset.swatch = swatch.dataset.swatch;
    const dot = document.createElement('span');
    dot.className = 'swatch__chip pick-chip__dot';
    if (source && source.getAttribute('style')) dot.setAttribute('style', source.getAttribute('style'));
    const text = document.createElement('span');
    text.textContent = input.dataset.title || input.value || '';
    chip.append(dot, text);
    if (removeIndex != null) {
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'pick-chip__remove';
      remove.dataset.pickRemove = String(removeIndex);
      remove.setAttribute('aria-label', `${T.strings.remove || 'Remove'} ${input.dataset.title || ''}`);
      remove.textContent = '×';
      chip.append(remove);
    }
    return chip;
  };

  const renderOptionLabels = () => {
    const opts = selectedOptions();
    $$('[data-option-position]', root).forEach((fieldset) => {
      const label = $('[data-option-value-label]', fieldset);
      const pos = Number(fieldset.dataset.optionPosition) - 1;
      if (!label) return;
      const checked = $('[data-option-input]:checked', fieldset);
      if ((label.classList.contains('variant-option__pick') || label.classList.contains('bundle-group__picks')) && checked) label.replaceChildren(chipFor(checked, null));
      else label.textContent = opts[pos] || '';
    });
  };

  const renderOptionAvailability = () => {
    const opts = selectedOptions();
    optionInputs().forEach((input) => {
      if (input.type !== 'radio') return;
      const pos = Number(input.dataset.optionPosition) - 1;
      const purchasable = data.variants.some((v) => v.available && v.options.every((o, i) => (i === pos ? o === input.value : (opts[i] == null || o === opts[i]))));
      const holder = input.closest('.swatch, .pill-option');
      if (holder) holder.classList.toggle('is-unavailable', !purchasable);
    });
  };

  const updateUrl = (v) => {
    if (!v || !window.history.replaceState) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  };

  const onVariantChange = () => {
    const v = data.hasOnlyDefaultVariant ? data.variants[0] : findVariant(selectedOptions());
    currentVariant = v || null;
    if (v) {
      if (idInput) idInput.value = v.id;
      renderPrice(v);
      updateUrl(v);
      if (v.mediaId) gallery.goToMedia(v.mediaId);
      // stock cap for the quantity stepper (tracked variants that do not allow overselling)
      const qtyInput = form ? $('[data-qty-input]', form) : null;
      if (qtyInput) {
        if (v.maxQty != null && v.maxQty > 0) { qtyInput.max = v.maxQty; if (Number(qtyInput.value) > v.maxQty) qtyInput.value = v.maxQty; }
        else qtyInput.removeAttribute('max');
      }
    }
    renderAvailability(v);
    renderOptionLabels();
    renderOptionAvailability();
    hideError();
  };

  root.addEventListener('change', (e) => { if (e.target.closest('[data-option-input]')) onVariantChange(); });
  renderOptionLabels();
  renderOptionAvailability();

  /* ---------------------------------------------------------------- bundle */
  /* Bundle groups live in two places: the peer "Color 2" picker inside the variant picker and the
     cream / charm suite / extras card. Both are plain [data-bundle-group] fieldsets. */
  const bundleConfigEl = $('[data-bundle-config]', root);
  const bundleConfig = bundleConfigEl ? JSON.parse(bundleConfigEl.textContent) : null;
  const groups = bundleConfig ? $$('[data-bundle-group]', root) : [];
  const bundleError = $('[data-bundle-error]', root);

  const hideBundleError = () => { if (bundleError) bundleError.hidden = true; };
  const showBundleError = (message, group) => {
    if (bundleError) { bundleError.textContent = message; bundleError.hidden = false; }
    if (group) {
      group.classList.add('is-invalid');
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  groups.forEach((group) => {
    const picks = []; // ordered, one entry per unit — the same input may appear several times
    selectionOrder.set(group, picks);
    const max = Number(group.dataset.max) || 1;
    const inputs = $$('[data-bundle-input]', group);
    const counter = $('[data-bundle-selected]', group);
    const valueLabel = $('[data-bundle-value]', group);
    const emptyLabel = valueLabel ? valueLabel.textContent : '';
    const asChips = valueLabel && (valueLabel.classList.contains('bundle-group__picks') || valueLabel.classList.contains('variant-option__pick'));
    const removable = valueLabel && !valueLabel.hasAttribute('data-no-remove');
    const countOf = (input) => picks.filter((p) => p === input).length;

    const render = () => {
      inputs.forEach((input) => {
        const n = countOf(input);
        input.checked = n > 0;
        const badge = input.closest('.swatch') ? $('[data-swatch-count]', input.closest('.swatch')) : null;
        if (badge) badge.textContent = n > 1 ? `×${n}` : '';
      });
      const count = picks.length;
      if (counter) counter.textContent = count;
      if (valueLabel) {
        if (asChips) valueLabel.replaceChildren(...picks.map((input, index) => chipFor(input, removable ? index : null)));
        else valueLabel.textContent = count ? picks.map((i) => i.dataset.title).join(', ') : emptyLabel;
      }
      group.classList.toggle('is-complete', count === max);
      if (count > 0) group.classList.remove('is-invalid');
      hideBundleError();
      renderExtrasTotal();
      renderButtonLabel(currentVariant);
      renderButtonState(currentVariant);
    };

    /* Click = add one unit (FIFO swap when the limit is reached). Single-pick groups toggle instead. */
    group.addEventListener('click', (e) => {
      const input = e.target.closest('[data-bundle-input]');
      if (!input || input.disabled) return;
      // The native toggle already happened; render() below overwrites `checked` from the picks list.
      // (Calling preventDefault here would make the browser revert any `checked` we set — a known gotcha.)
      if (max === 1 && countOf(input) > 0) picks.length = 0;
      else {
        picks.push(input);
        while (picks.length > max) picks.shift();
        if (input.dataset.mediaId) gallery.goToMedia(input.dataset.mediaId); // Second Color shares the product photos
      }
      render();
    });
    if (valueLabel) valueLabel.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-pick-remove]');
      if (!remove) return;
      picks.splice(Number(remove.dataset.pickRemove), 1);
      render();
    });
    render();
  });
  renderExtrasTotal();

  const validateBundle = () => {
    for (const group of groups) {
      if (group.dataset.role !== 'included') continue;
      const max = Number(group.dataset.max) || 0;
      if (picksOf(group).length < max) { showBundleError(T.strings.missingSelection, group); return false; }
    }
    return true;
  };

  /* Aggregate a group's picks into [input, units] pairs (insertion order kept). */
  const aggregated = (group) => {
    const map = new Map();
    picksOf(group).forEach((input) => map.set(input, (map.get(input) || 0) + 1));
    return [...map.entries()];
  };

  const uid = () => (window.crypto && typeof window.crypto.randomUUID === 'function'
    ? window.crypto.randomUUID()
    : Date.now().toString(36) + Math.random().toString(36).slice(2, 10));

  /* Build the items array for /cart/add.js: parent line (+ component lines in "lines" mode). */
  const buildItems = (quantity) => {
    const parentProps = {};
    const parent = { id: Number(idInput.value), quantity, properties: parentProps };
    if (!bundleConfig) return [parent];

    const bundleId = uid();
    const lines = bundleConfig.mode === 'lines';
    const components = [];

    groups.forEach((group) => {
      const selected = aggregated(group); // [input, units]
      if (!selected.length) return;
      const role = group.dataset.role;
      // A pick is stored EITHER as a readable property on the parent (properties mode, included groups)
      // OR as its own cart line (extras always, included groups in lines mode) — never both.
      if (role === 'included' && !lines) {
        parentProps[group.dataset.label] = selected.map(([input, units]) => (units > 1 ? `${input.dataset.title} ×${units}` : input.dataset.title)).join(', ');
        return;
      }
      const label = role === 'extra' ? bundleConfig.labels.added_to : bundleConfig.labels.included_with;
      selected.forEach(([input, units]) => components.push({
        id: Number(input.dataset.variantId),
        quantity: quantity * units,
        properties: { [label]: bundleConfig.parentTitle, _bundle_id: bundleId, _bundle_role: role },
      }));
    });

    // Tools: a real cart line per kit when the function is live OR when the tool product itself is priced at
    // $0 (nothing to re-price); otherwise a readable property so the order still tells the packers.
    const tools = bundleConfig.tools || [];
    const asLine = (tool) => lines || Number(tool.price) === 0;
    tools.filter(asLine).forEach((tool) => components.push({
      id: Number(tool.id),
      quantity: quantity * (Number(tool.quantity) || 1),
      properties: { [bundleConfig.labels.included_with]: bundleConfig.parentTitle, _bundle_id: bundleId, _bundle_role: 'tool' },
    }));
    const pending = tools.filter((tool) => !asLine(tool));
    if (pending.length) {
      parentProps[bundleConfig.labels.included_tools] = pending
        .map((tool) => ((Number(tool.quantity) || 1) > 1 ? `${tool.title} ×${tool.quantity}` : tool.title))
        .join(', ');
    }

    // Any customised item is a "set" in the cart, whether its picks are component lines or properties.
    if (components.length || Object.keys(parentProps).length) {
      parentProps._bundle_id = bundleId;
      parentProps._bundle_role = 'parent';
    }
    return [parent, ...components];
  };

  /* ------------------------------------------------------------ add to cart */
  if (form) form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!currentVariant || !currentVariant.available || !addBtn) return;
    hideError();
    if (bundleConfig && !validateBundle()) return;
    const qtyInput = $('[data-qty-input]', form);
    const quantity = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
    addBtn.classList.add('is-loading');
    addBtn.disabled = true;
    try {
      await T.cart.add(buildItems(quantity));
      T.openDrawer('CartDrawer');
    } catch (err) {
      showError(err.message || T.strings.genericError);
    } finally {
      addBtn.classList.remove('is-loading');
      addBtn.disabled = false;
    }
  });

  /* ----------------------------------------------------------- sticky bar */
  if (cartBar && addBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      cartBar.hidden = !show;
      cartBar.classList.toggle('is-visible', show);
    }, { threshold: 0 });
    io.observe(addBtn);
    const barBtn = $('[data-cart-bar-button]', cartBar);
    if (barBtn) barBtn.addEventListener('click', () => {
      addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => addBtn.focus({ preventScroll: true }), 500);
    });
  }

  /* Re-open the notify-me dialog after Shopify redirects back with a success/error message */
  const notifyDialog = document.getElementById('NotifyDialog');
  if (notifyDialog && $('.form__success, .form__errors', notifyDialog) && typeof notifyDialog.showModal === 'function') {
    notifyDialog.showModal();
  }

  /* ------------------------------------------------------ related products */
  const related = $('[data-related-products]');
  if (related && related.dataset.url) {
    fetch(related.dataset.url)
      .then((res) => (res.ok ? res.text() : ''))
      .then((html) => {
        if (!html) return;
        const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.related');
        if (inner) { related.appendChild(inner); if (T.reveal) T.reveal(); }
      })
      .catch(() => {});
  }
})();
